import PaymentView from "../pages/Views/Transactions/PaymentView"
import Invite from "../pages/Auth/Invite"
import Loading from "../pages/layouts/Loading"
import Welcome from "../pages/Auth/Welcome"
import PublicLegalRedirect from "../pages/Auth/PublicLegalRedirect"
import EmailUnsubscribe from "../pages/EmailPreferences/Unsubscribe"
import EmailResubscribe from "../pages/EmailPreferences/Resubscribe"

const sharedRoutes = [
    {
        path: "/welcome",
        element: <Welcome />,
        errorElement: <Loading />,
    },
    {
        path: "/invite",
        element: <Invite />,
        errorElement: <Loading />,
    },
    {
        path: "/termos-de-servico",
        element: <PublicLegalRedirect path="/termos-de-servico/" />,
        errorElement: <Loading />,
    },
    {
        path: "/politica-de-privacidade",
        element: <PublicLegalRedirect path="/politica-de-privacidade/" />,
        errorElement: <Loading />,
    },
    {
        path: "/email-preferences/unsubscribe",
        element: <EmailUnsubscribe />,
        errorElement: <Loading />,
    },
    {
        path: "/email-preferences/resubscribe",
        element: <EmailResubscribe />,
        errorElement: <Loading />,
    },
    {
        path: "/view/transactions/:transaction_id/:charge_id/payment",
        element: <PaymentView />,
        errorElement: <Loading />,
    },
]

export default sharedRoutes
